import { Box, Grid, Icon, Tooltip, Typography } from "@mui/material"
import { icons } from "../../../../../../../../utils/icons"
import { useUserAssigned } from "./userAssignedStyles"

const UserAssigned = (props: any) => {
  const styles = useUserAssigned()
  let usersAssigned = props?.current
  return (
    <Grid
      container
      justifyContent="left"
      alignItems="center"
      columnSpacing={1}
    >
      <Grid
        item
        sx={{ color: '#828282' }}
        xl={10}
        lg={10}
        md={10}
        sm={10}
        xs={10}
      >
        <Typography sx={styles.textItem}>
          {usersAssigned.length ? (
            <span>{usersAssigned[0].assignFullName}</span>
          ) : (
            'N/A'
          )}
        </Typography>
      </Grid>

    </Grid>
  )
}

export { UserAssigned }
